export default {
  'menu.user.info': '用户信息',
  'userInfo.editUserInfo': '编辑信息',
  'userInfo.tab.title.overview': '总览',
  'userInfo.tab.title.project': '项目',
  'userInfo.tab.title.team': '我的团队',
  'userInfo.title.latestActivity': '最新动态',
  'userInfo.title.latestNotification': '站内通知',
  'userInfo.title.myProject': '我的项目',
  'userInfo.showMore': '查看更多',
  'userInfo.viewAll': '查看全部',
  'userInfo.nodata': '暂无数据',
  'userInfo.visits.unit': '人次',
  'userInfo.visits.lastMonth': '较上月',
};
